<template>
  <div v-if="d_usrSupportWdm">
    <b-row>
      <b-col sm="12" lg="2"></b-col>
      <b-col sm="12" lg="8"></b-col>
      <b-col sm="12" lg="2"></b-col>
    </b-row>
    <b-row v-if="!p_callFrom || p_callFrom !== 'default_container'" style="margin-bottom: 20px; border-bottom: solid 1px whitesmoke;">
      <b-col sm="12" md="2" lg="2"> </b-col>
      <b-col sm="12" md="4" lg="4">
        <i class="fa fa-desktop"></i>
        {{ StoreLangTranslation.data['support_requests'][StoreLang] }}
      </b-col>
      <b-col sm="12" md="4" lg="4" :style="StoreDevice.isMobile ? '' : 'text-align: right;'"></b-col>
      <b-col sm="12" md="2" lg="2"></b-col>
    </b-row>
    <template v-if="p_callFrom == 'default_container'">
      <div v-if="ClsUser.f_checkUserAuth(['admin', 'support_admin'])"  style="margin-top: -45px;">
        <b-row>
          <b-col cols="4"></b-col>
          <b-col cols="8">
            <b-form-select v-model="d_selectedSupportTab" :disabled="d_supportListLoading">
              <option value="own">Own supports</option>
              <option value="all">All supports</option>
              <option value="user">User supports</option>
              <option value="mail">Mail supports</option>
            </b-form-select>
          </b-col>
        </b-row>
      </div>
      <template v-if="!d_supportListLoading && ((ClsUser.f_checkUserAuth(['admin', 'support_admin']) && d_selectedSupportTab == 'own') || !ClsUser.f_checkUserAuth(['admin', 'support_admin']))">
        <b-row style="font-size: 14px; margin-top: 10px;">
          <b-col sm="12" lg="12">
            <b-row style="margin-bottom: 10px;">
              <b-col sm="12" lg="12" style="text-align: center;">
                <b-button @click="f_openSupportModal()" style="width: 100%;" variant="primary">
                  <i class="fa fa-plus-circle"></i>
                  {{ StoreLangTranslation.data['new_support_request'][StoreLang] }}
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12" lg="12">
                <b-form-input id="search" v-model="d_searchText" :placeholder="StoreLangTranslation.data['write_for_filtering'][StoreLang]"></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="2">
                <strong> {{ d_usrSupportWdm['0']['parameters']['0']['name']['translation'][StoreLang] }} </strong>
              </b-col>
              <!-- <b-col sm="12" lg="2">
                <strong> {{ d_usrSupportWdm['0']['parameters']['12']['name']['translation'][StoreLang] }} </strong>
              </b-col> -->
              <b-col cols="10">
                <strong> {{ d_usrSupportWdm['0']['parameters']['8']['name']['translation'][StoreLang] }} </strong>
              </b-col>
              <!-- <b-col sm="12" lg="2">
                <strong> {{ d_usrSupportWdm['0']['parameters']['3']['name']['translation'][StoreLang] }} </strong>
              </b-col>
              <b-col sm="12" lg="1"> </b-col> -->
            </b-row>
            <div style="height: 370px !important; overflow-y: auto; overflow-x: hidden;">
              <b-row v-for="(wdmr_item, wdmr_item_ind) in d_userSupportList" v-if="f_searchWdmritem(wdmr_item)" @mouseover="d_hoverIndex = wdmr_item_ind" @mouseleave="d_hoverIndex = ''" :style="StoreDevice.isMobile ? 'cursor: pointer; border-bottom: solid 1px #dcdcdc;' : 'cursor: pointer; border-bottom: solid 1px #dcdcdc;'" @click="f_selectThisSupport(wdmr_item.client_id, '')" :class="p_callFrom === 'default_container' && p_selectedSupportId === wdmr_item.client_id ? 'selected' : ''">
                <b-col cols="2">
                  <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['0'] && wdmr_item.data['0']['0']['val']['translation']">
                    <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : wdmr_item.data['0']['0']['val']['value'] === '1' ? 'color: green;' : 'color: red;'">{{ wdmr_item.data['0']['0']['val']['translation'][StoreLang] }}</span>
                  </template>
                </b-col>
                <!-- <b-col sm="12" lg="2">
                  <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['12'] && wdmr_item.data['0']['12']['val']">
                    <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ f_dateFormat(wdmr_item.data['0']['12']['val'], 'year-month-day hh:mm') }}</span>
                  </template>
                </b-col> -->
                <b-col cols="10">
                  <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['8'] && wdmr_item.data['0']['8']['lang'] && wdmr_item.data['0']['8']['lang'][StoreLang]">
                    <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['8']['lang'][StoreLang] }}</span>
                  </template>
                  <template v-else-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['8'] && wdmr_item.data['0']['8']['val']">
                    <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['8']['val'] }}</span>
                  </template>
                </b-col>
                <!-- <b-col sm="12" lg="2">
                  <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['3'] && wdmr_item.data['0']['3']['lang'] && wdmr_item.data['0']['3']['lang'][StoreLang]">
                    <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['3']['lang'][StoreLang] }}</span>
                  </template>
                  <template v-else-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['3'] && wdmr_item.data['0']['3']['val']">
                    <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['3']['val'] }}</span>
                  </template>
                </b-col>
                <b-col sm="12" lg="1">
                  <b-dropdown variant="white" size="sm" style="width: 100%; float: left;">
                    <template slot="button-content">
                      işlem
                    </template>
                    <b-dropdown-item v-if="d_user" @click="f_supportDetails(wdmr_item.client_id)"><i class="fa fa-edit"></i> {{ StoreLangTranslation.data['support_details'][StoreLang] }} </b-dropdown-item>
                    <b-dropdown-item v-if="d_user" @click="f_userSupportTerminate(wdmr_item.client_id)"><i class="fa fa-edit"></i> {{ StoreLangTranslation.data['support_terminate'][StoreLang] }} </b-dropdown-item>
                  </b-dropdown>
                </b-col> -->
                <hr/>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </template>
      <template v-else-if="!d_supportListLoading && ((ClsUser.f_checkUserAuth(['admin', 'support_admin']) && d_selectedSupportTab == 'all') || !ClsUser.f_checkUserAuth(['admin', 'support_admin']))">
        <b-row style="font-size: 14px; margin-top: 10px;">
          <b-col sm="12" lg="12">
            <b-row style="margin-bottom: 10px;">
              <b-col cols="3" style="text-align: center;">
                <b-button @click="f_getLastSupports()" style="width: 100%;" variant="primary">
                  <i class="fa fa-refresh"></i>
                </b-button>
              </b-col>
              <b-col cols="9" style="text-align: center;">
                <b-button @click="f_passiveSelectedSupports()" style="width: 100%;" variant="outline-danger" :disabled='d_passiveSelectedLoading'>
                  seçililer pasif
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12" lg="12">
                <b-form-input id="search" v-model="d_searchText" :placeholder="StoreLangTranslation.data['write_for_filtering'][StoreLang]"></b-form-input>
              </b-col>
            </b-row>
            <!-- <b-row>
              <b-col cols="2">
                <strong> {{ d_usrSupportWdm['0']['parameters']['0']['name']['translation'][StoreLang] }} </strong>
              </b-col> -->
              <!-- <b-col sm="12" lg="2">
                <strong> {{ d_usrSupportWdm['0']['parameters']['12']['name']['translation'][StoreLang] }} </strong>
              </b-col> -->
              <!-- <b-col cols="10">
                <strong> {{ d_usrSupportWdm['0']['parameters']['8']['name']['translation'][StoreLang] }} </strong>
              </b-col> -->
              <!-- <b-col sm="12" lg="2">
                <strong> {{ d_usrSupportWdm['0']['parameters']['3']['name']['translation'][StoreLang] }} </strong>
              </b-col>
              <b-col sm="12" lg="1"> </b-col> -->
            <!-- </b-row> -->
            <div style="height: 370px !important; overflow-y: auto; overflow-x: hidden;">
              <div v-for="(user_item, user_item_ind) in d_allSupportList['user_support']['user_list']">
                <strong>{{ user_item_ind }}</strong>
                <b-row v-for="(wdmr_item, wdmr_item_ind) in user_item" v-if="f_searchWdmritem(wdmr_item)">
                  <!-- <b-col cols="2">
                    <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['0'] && wdmr_item.data['0']['0']['val']['translation']">
                      <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : wdmr_item.data['0']['0']['val']['value'] === '1' ? 'color: green;' : 'color: red;'">{{ wdmr_item.data['0']['0']['val']['translation'][StoreLang] }}</span>
                    </template>
                  </b-col> -->
                  <b-col cols="2">
                    <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['0'] && wdmr_item.data['0']['0']['val']['translation']">
                      <b-form-checkbox
                        v-model="d_toBePassive['user_support'][wdmr_item.client_id]"
                        value="1"
                        :id="'checkbox_' + user_item_ind + '_' + wdmr_item_ind"
                      ></b-form-checkbox>
                    </template>
                  </b-col>
                  <!-- <b-col sm="12" lg="2">
                    <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['12'] && wdmr_item.data['0']['12']['val']">
                      <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ f_dateFormat(wdmr_item.data['0']['12']['val'], 'year-month-day hh:mm') }}</span>
                    </template>
                  </b-col> -->
                  <b-col cols="10" @mouseover="d_hoverIndex = wdmr_item_ind" @mouseleave="d_hoverIndex = ''" :style="StoreDevice.isMobile ? 'cursor: pointer; border-bottom: solid 1px #dcdcdc;' : 'cursor: pointer; border-bottom: solid 1px #dcdcdc;'" @click="f_selectThisSupport(wdmr_item.client_id, 'user')" :class="p_callFrom === 'default_container' && p_selectedSupportId === wdmr_item.client_id ? 'selected' : ''">
                    <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['8'] && wdmr_item.data['0']['8']['lang'] && wdmr_item.data['0']['8']['lang'][StoreLang]">
                      <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['8']['lang'][StoreLang] }}</span>
                    </template>
                    <template v-else-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['8'] && wdmr_item.data['0']['8']['val']">
                      <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['8']['val'] }}</span>
                    </template>
                  </b-col>
                  <!-- <b-col sm="12" lg="2">
                    <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['3'] && wdmr_item.data['0']['3']['lang'] && wdmr_item.data['0']['3']['lang'][StoreLang]">
                      <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['3']['lang'][StoreLang] }}</span>
                    </template>
                    <template v-else-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['3'] && wdmr_item.data['0']['3']['val']">
                      <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['3']['val'] }}</span>
                    </template>
                  </b-col>
                  <b-col sm="12" lg="1">
                    <b-dropdown variant="white" size="sm" style="width: 100%; float: left;">
                      <template slot="button-content">
                        işlem
                      </template>
                      <b-dropdown-item v-if="d_user" @click="f_supportDetails(wdmr_item.client_id)"><i class="fa fa-edit"></i> {{ StoreLangTranslation.data['support_details'][StoreLang] }} </b-dropdown-item>
                      <b-dropdown-item v-if="d_user" @click="f_userSupportTerminate(wdmr_item.client_id)"><i class="fa fa-edit"></i> {{ StoreLangTranslation.data['support_terminate'][StoreLang] }} </b-dropdown-item>
                    </b-dropdown>
                  </b-col> -->
                  <hr/>
                </b-row>
              </div>
              <div v-for="(mail_item, mail_item_ind) in d_allSupportList['mail_support']['mail_list']">
                <strong>{{ mail_item_ind }}</strong>
                <b-row v-for="(wdmr_item, wdmr_item_ind) in mail_item" v-if="f_searchWdmritem(wdmr_item)">
                  <!-- <b-col cols="2">
                    <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['0'] && wdmr_item.data['0']['0']['val']['translation']">
                      <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : wdmr_item.data['0']['0']['val']['value'] === '1' ? 'color: green;' : 'color: red;'">{{ wdmr_item.data['0']['0']['val']['translation'][StoreLang] }}</span>
                    </template>
                  </b-col> -->
                  <b-col cols="2">
                    <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['0'] && wdmr_item.data['0']['0']['val']['translation']">
                      <b-form-checkbox
                        v-model="d_toBePassive['mail_support'][wdmr_item.client_id]"
                        value="1"
                        :id="'checkbox_' + mail_item_ind + '_' + wdmr_item_ind"
                      ></b-form-checkbox>
                    </template>
                  </b-col>
                  <!-- <b-col sm="12" lg="2">
                    <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['12'] && wdmr_item.data['0']['12']['val']">
                      <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ f_dateFormat(wdmr_item.data['0']['12']['val'], 'year-month-day hh:mm') }}</span>
                    </template>
                  </b-col> -->
                  <b-col cols="10" @mouseover="d_hoverIndex = wdmr_item_ind" @mouseleave="d_hoverIndex = ''" :style="StoreDevice.isMobile ? 'cursor: pointer; border-bottom: solid 1px #dcdcdc;' : 'cursor: pointer; border-bottom: solid 1px #dcdcdc;'" @click="f_selectThisSupport(wdmr_item.client_id, 'mail')" :class="p_callFrom === 'default_container' && p_selectedSupportId === wdmr_item.client_id ? 'selected' : ''">
                    <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['8'] && wdmr_item.data['0']['8']['lang'] && wdmr_item.data['0']['8']['lang'][StoreLang]">
                      <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['8']['lang'][StoreLang] }}</span>
                    </template>
                    <template v-else-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['8'] && wdmr_item.data['0']['8']['val']">
                      <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['8']['val'] }}</span>
                    </template>
                  </b-col>
                  <!-- <b-col sm="12" lg="2">
                    <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['3'] && wdmr_item.data['0']['3']['lang'] && wdmr_item.data['0']['3']['lang'][StoreLang]">
                      <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['3']['lang'][StoreLang] }}</span>
                    </template>
                    <template v-else-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['3'] && wdmr_item.data['0']['3']['val']">
                      <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['3']['val'] }}</span>
                    </template>
                  </b-col>
                  <b-col sm="12" lg="1">
                    <b-dropdown variant="white" size="sm" style="width: 100%; float: left;">
                      <template slot="button-content">
                        işlem
                      </template>
                      <b-dropdown-item v-if="d_user" @click="f_supportDetails(wdmr_item.client_id)"><i class="fa fa-edit"></i> {{ StoreLangTranslation.data['support_details'][StoreLang] }} </b-dropdown-item>
                      <b-dropdown-item v-if="d_user" @click="f_userSupportTerminate(wdmr_item.client_id)"><i class="fa fa-edit"></i> {{ StoreLangTranslation.data['support_terminate'][StoreLang] }} </b-dropdown-item>
                    </b-dropdown>
                  </b-col> -->
                  <hr/>
                </b-row>
              </div>
            </div>
          </b-col>
        </b-row>
      </template>
      <template v-else-if="!d_supportListLoading && ((ClsUser.f_checkUserAuth(['admin', 'support_admin']) && d_selectedSupportTab == 'user') || !ClsUser.f_checkUserAuth(['admin', 'support_admin']))">
        <b-row style="font-size: 14px; margin-top: 10px;">
          <b-col sm="12" lg="12">
            <b-row>
              <b-col cols="9">
                <b-form-input id="search" v-model="d_searchUser" :placeholder="StoreLangTranslation.data['username'][StoreLang]"></b-form-input>
              </b-col>
              <b-col cols="3">
                <b-button variant="outline-primary" @click="f_userSupportList(d_searchUser)" :disabled="!d_searchUser">
                  <i class="fa fa-paper-plane"></i>
                </b-button>
              </b-col>
            </b-row>
            <hr/>
            <b-row>
              <b-col sm="12" lg="12">
                <b-form-input id="search" v-model="d_searchText" :placeholder="StoreLangTranslation.data['write_for_filtering'][StoreLang]"></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="2">
                <strong> {{ d_usrSupportWdm['0']['parameters']['0']['name']['translation'][StoreLang] }} </strong>
              </b-col>
              <!-- <b-col sm="12" lg="2">
                <strong> {{ d_usrSupportWdm['0']['parameters']['12']['name']['translation'][StoreLang] }} </strong>
              </b-col> -->
              <b-col cols="10">
                <strong> {{ d_usrSupportWdm['0']['parameters']['8']['name']['translation'][StoreLang] }} </strong>
              </b-col>
              <!-- <b-col sm="12" lg="2">
                <strong> {{ d_usrSupportWdm['0']['parameters']['3']['name']['translation'][StoreLang] }} </strong>
              </b-col>
              <b-col sm="12" lg="1"> </b-col> -->
            </b-row>
            <div style="height: 340px !important; overflow-y: auto; overflow-x: hidden;">
              <b-row v-for="(wdmr_item, wdmr_item_ind) in d_userSupportList" v-if="f_searchWdmritem(wdmr_item)" @mouseover="d_hoverIndex = wdmr_item_ind" @mouseleave="d_hoverIndex = ''" :style="StoreDevice.isMobile ? 'cursor: pointer; border-bottom: solid 1px #dcdcdc;' : 'cursor: pointer; border-bottom: solid 1px #dcdcdc;'" @click="f_selectThisSupport(wdmr_item.client_id, 'user')" :class="p_callFrom === 'default_container' && p_selectedSupportId === wdmr_item.client_id ? 'selected' : ''">
                <b-col cols="2">
                  <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['0'] && wdmr_item.data['0']['0']['val']['translation']">
                    <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : wdmr_item.data['0']['0']['val']['value'] === '1' ? 'color: green;' : 'color: red;'">{{ wdmr_item.data['0']['0']['val']['translation'][StoreLang] }}</span>
                  </template>
                </b-col>
                <!-- <b-col sm="12" lg="2">
                  <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['12'] && wdmr_item.data['0']['12']['val']">
                    <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ f_dateFormat(wdmr_item.data['0']['12']['val'], 'year-month-day hh:mm') }}</span>
                  </template>
                </b-col> -->
                <b-col cols="10">
                  <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['8'] && wdmr_item.data['0']['8']['lang'] && wdmr_item.data['0']['8']['lang'][StoreLang]">
                    <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['8']['lang'][StoreLang] }}</span>
                  </template>
                  <template v-else-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['8'] && wdmr_item.data['0']['8']['val']">
                    <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['8']['val'] }}</span>
                  </template>
                </b-col>
                <!-- <b-col sm="12" lg="2">
                  <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['3'] && wdmr_item.data['0']['3']['lang'] && wdmr_item.data['0']['3']['lang'][StoreLang]">
                    <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['3']['lang'][StoreLang] }}</span>
                  </template>
                  <template v-else-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['3'] && wdmr_item.data['0']['3']['val']">
                    <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['3']['val'] }}</span>
                  </template>
                </b-col>
                <b-col sm="12" lg="1">
                  <b-dropdown variant="white" size="sm" style="width: 100%; float: left;">
                    <template slot="button-content">
                      işlem
                    </template>
                    <b-dropdown-item v-if="d_user" @click="f_supportDetails(wdmr_item.client_id)"><i class="fa fa-edit"></i> {{ StoreLangTranslation.data['support_details'][StoreLang] }} </b-dropdown-item>
                    <b-dropdown-item v-if="d_user" @click="f_userSupportTerminate(wdmr_item.client_id)"><i class="fa fa-edit"></i> {{ StoreLangTranslation.data['support_terminate'][StoreLang] }} </b-dropdown-item>
                  </b-dropdown>
                </b-col> -->
                <hr/>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </template>
      <template v-else-if="!d_supportListLoading && ((ClsUser.f_checkUserAuth(['admin', 'support_admin']) && d_selectedSupportTab == 'mail') || !ClsUser.f_checkUserAuth(['admin', 'support_admin']))">
        <b-row style="font-size: 14px; margin-top: 10px;">
          <b-col sm="12" lg="12">
            <b-row>
              <b-col sm="9" lg="9">
                <b-form-input id="search" v-model="d_searchUser" :placeholder="StoreLangTranslation.data['mail'][StoreLang]"></b-form-input>
              </b-col>
              <b-col sm="3" lg="3">
                <b-button variant="outline-primary" @click="f_mailSupportList(d_searchUser)" :disabled="!d_searchUser">
                  <i class="fa fa-paper-plane"></i>
                </b-button>
              </b-col>
            </b-row>
            <hr/>
            <b-row>
              <b-col sm="12" lg="12">
                <b-form-input id="search" v-model="d_searchText" :placeholder="StoreLangTranslation.data['write_for_filtering'][StoreLang]"></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="2">
                <strong> {{ d_usrSupportWdm['0']['parameters']['0']['name']['translation'][StoreLang] }} </strong>
              </b-col>
              <!-- <b-col sm="12" lg="2">
                <strong> {{ d_usrSupportWdm['0']['parameters']['12']['name']['translation'][StoreLang] }} </strong>
              </b-col> -->
              <b-col cols="10">
                <strong> {{ d_usrSupportWdm['0']['parameters']['8']['name']['translation'][StoreLang] }} </strong>
              </b-col>
              <!-- <b-col sm="12" lg="2">
                <strong> {{ d_usrSupportWdm['0']['parameters']['3']['name']['translation'][StoreLang] }} </strong>
              </b-col>
              <b-col sm="12" lg="1"> </b-col> -->
            </b-row>
            <div style="height: 340px !important; overflow-y: auto; overflow-x: hidden;">
              <b-row v-for="(wdmr_item, wdmr_item_ind) in d_userSupportList" v-if="f_searchWdmritem(wdmr_item)" @mouseover="d_hoverIndex = wdmr_item_ind" @mouseleave="d_hoverIndex = ''" :style="StoreDevice.isMobile ? 'cursor: pointer; border-bottom: solid 1px #dcdcdc;' : 'cursor: pointer; border-bottom: solid 1px #dcdcdc;'" @click="f_selectThisSupport(wdmr_item.client_id, 'mail')" :class="p_callFrom === 'default_container' && p_selectedSupportId === wdmr_item.client_id ? 'selected' : ''">
                <b-col cols="2">
                  <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['0'] && wdmr_item.data['0']['0']['val']['translation']">
                    <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : wdmr_item.data['0']['0']['val']['value'] === '1' ? 'color: green;' : 'color: red;'">{{ wdmr_item.data['0']['0']['val']['translation'][StoreLang] }}</span>
                  </template>
                </b-col>
                <!-- <b-col sm="12" lg="2">
                  <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['12'] && wdmr_item.data['0']['12']['val']">
                    <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ f_dateFormat(wdmr_item.data['0']['12']['val'], 'year-month-day hh:mm') }}</span>
                  </template>
                </b-col> -->
                <b-col cols="10">
                  <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['8'] && wdmr_item.data['0']['8']['lang'] && wdmr_item.data['0']['8']['lang'][StoreLang]">
                    <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['8']['lang'][StoreLang] }}</span>
                  </template>
                  <template v-else-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['8'] && wdmr_item.data['0']['8']['val']">
                    <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['8']['val'] }}</span>
                  </template>
                </b-col>
                <!-- <b-col sm="12" lg="2">
                  <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['3'] && wdmr_item.data['0']['3']['lang'] && wdmr_item.data['0']['3']['lang'][StoreLang]">
                    <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['3']['lang'][StoreLang] }}</span>
                  </template>
                  <template v-else-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['3'] && wdmr_item.data['0']['3']['val']">
                    <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['3']['val'] }}</span>
                  </template>
                </b-col>
                <b-col sm="12" lg="1">
                  <b-dropdown variant="white" size="sm" style="width: 100%; float: left;">
                    <template slot="button-content">
                      işlem
                    </template>
                    <b-dropdown-item v-if="d_user" @click="f_supportDetails(wdmr_item.client_id)"><i class="fa fa-edit"></i> {{ StoreLangTranslation.data['support_details'][StoreLang] }} </b-dropdown-item>
                    <b-dropdown-item v-if="d_user" @click="f_userSupportTerminate(wdmr_item.client_id)"><i class="fa fa-edit"></i> {{ StoreLangTranslation.data['support_terminate'][StoreLang] }} </b-dropdown-item>
                  </b-dropdown>
                </b-col> -->
                <hr/>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </template>
      <template v-else>
        <b-spinner variant="primary" label="Continuing" style="margin: 2px;"></b-spinner>
      </template>
    </template>
    <b-row v-else style="font-size: 14px;">
      <b-col sm="12" lg="2"></b-col>
      <b-col sm="12" lg="8">
        <b-row style="margin-bottom: 10px;">
          <b-col sm="12" lg="6"> </b-col>
          <b-col sm="12" lg="6" style="text-align: right;">
            <b-button size="sm" @click="f_supportModal()" variant="white">
              <i class="fa fa-plus-circle"></i>
              {{ StoreLangTranslation.data['new_support_request'][StoreLang] }}
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" lg="12">
            <b-form-input id="search" v-model="d_searchText" :placeholder="StoreLangTranslation.data['write_for_filtering'][StoreLang]"></b-form-input>
          </b-col>
        </b-row>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="1">
            <strong> {{ d_usrSupportWdm['0']['parameters']['0']['name']['translation'][StoreLang] }} </strong>
          </b-col>
          <b-col sm="12" lg="2">
            <strong> {{ d_usrSupportWdm['0']['parameters']['12']['name']['translation'][StoreLang] }} </strong>
          </b-col>
          <b-col sm="12" lg="6">
            <strong> {{ d_usrSupportWdm['0']['parameters']['8']['name']['translation'][StoreLang] }} </strong>
          </b-col>
          <b-col sm="12" lg="2">
            <strong> {{ d_usrSupportWdm['0']['parameters']['3']['name']['translation'][StoreLang] }} </strong>
          </b-col>
          <b-col sm="12" lg="1"> </b-col>
        </b-row>
        <b-row v-for="(wdmr_item, wdmr_item_ind) in d_userSupportList" v-if="f_searchWdmritem(wdmr_item)" @mouseover="d_hoverIndex = wdmr_item_ind" @mouseleave="d_hoverIndex = ''" :style="StoreDevice.isMobile ? 'cursor: pointer; margin: 10px; border-bottom: solid 1px #dcdcdc;' : 'cursor: pointer; margin: 1px; border-bottom: solid 1px #dcdcdc;'" @click="f_selectThisSupport(wdmr_item.client_id)" :class="p_callFrom === 'default_container' && p_selectedSupportId === wdmr_item.client_id ? 'selected' : ''">
          <b-col sm="12" lg="1">
            <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['0'] && wdmr_item.data['0']['0']['val']['translation']">
              <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : wdmr_item.data['0']['0']['val']['value'] === '1' ? 'color: green;' : 'color: red;'">{{ wdmr_item.data['0']['0']['val']['translation'][StoreLang] }}</span>
            </template>
          </b-col>
          <b-col sm="12" lg="2">
            <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['12'] && wdmr_item.data['0']['12']['val']">
              <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ f_dateFormat(wdmr_item.data['0']['12']['val'], 'year-month-day hh:mm') }}</span>
            </template>
          </b-col>
          <b-col sm="12" lg="6">
            <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['8'] && wdmr_item.data['0']['8']['lang'] && wdmr_item.data['0']['8']['lang'][StoreLang]">
              <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['8']['lang'][StoreLang] }}</span>
            </template>
            <template v-else-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['8'] && wdmr_item.data['0']['8']['val']">
              <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['8']['val'] }}</span>
            </template>
          </b-col>
          <b-col sm="12" lg="2">
            <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['3'] && wdmr_item.data['0']['3']['lang'] && wdmr_item.data['0']['3']['lang'][StoreLang]">
              <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['3']['lang'][StoreLang] }}</span>
            </template>
            <template v-else-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['3'] && wdmr_item.data['0']['3']['val']">
              <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['3']['val'] }}</span>
            </template>
          </b-col>
          <b-col sm="12" lg="1">
            <b-dropdown variant="white" size="sm" style="width: 100%; float: left;">
              <template slot="button-content">
                işlem
              </template>
              <b-dropdown-item v-if="d_user" @click="f_supportDetails(wdmr_item.client_id)"><i class="fa fa-edit"></i> {{ StoreLangTranslation.data['support_details'][StoreLang] }} </b-dropdown-item>
              <b-dropdown-item v-if="d_user" @click="f_userSupportTerminate(wdmr_item.client_id)"><i class="fa fa-edit"></i> {{ StoreLangTranslation.data['support_terminate'][StoreLang] }} </b-dropdown-item>
            </b-dropdown>
          </b-col>
        </b-row>
      </b-col>
      <b-col sm="12" lg="2"></b-col>
    </b-row>

    <b-modal v-if="d_supportData.show" id="d_supportData_show" v-model="d_supportData.show" scrollable hide-footer :title="StoreLangTranslation.data['support_screen'][StoreLang]" centered header-bg-variant="info" header-text-variant="dark" size="lg" style="z-index: 999;">
      <p>
        <b-row>
          <b-col sm="12" lg="12">
            <support-screen :p_supportData="d_supportData" :f_userSupportList="f_userSupportList"></support-screen>
          </b-col>
        </b-row>
      </p>
      <p>
      <b-row>
          <b-col sm="12" lg="6"></b-col>
          <b-col sm="12" lg="6" style="text-align: right;">
          </b-col>
        </b-row>
      </p>
    </b-modal>
    <b-modal v-if="d_supportDataMail.show" id="d_supportDataMail_show" v-model="d_supportDataMail.show" scrollable hide-footer :title="StoreLangTranslation.data['support_screen'][StoreLang]" centered header-bg-variant="info" header-text-variant="dark" size="lg" style="z-index: 999;">
      <p>
        <b-row>
          <b-col sm="12" lg="12">
            <support-screen :f_clearMailInfo="f_clearMailInfo" :f_updateMailInfo="f_updateMailInfo" :p_supportData="d_supportDataMail" :f_mailSupportList="f_mailSupportList" :p_mailFilled="true"></support-screen>
          </b-col>
        </b-row>
      </p>
    </b-modal>
  </div>
</template>

<script>

import { ClsUser } from '@/wam/modules/user';
import { ClsWdm } from '@/wam/modules/wdm';
import { ClsRoute } from '@/wam/modules/route';
import store from '@/store';
import { ServiceFunctions } from '@/wam/modules/service';
import {
  default as PageInfo
} from '@/components/widgets/PageInfo';
import {
  default as SupportScreen
} from '@/wam/components/widgets/SupportScreen';
import { mapGetters } from 'vuex';
import moment from "moment";
export default {
  name: 'SupportList',
  computed: mapGetters({
    StoreDevice: 'StoreDevice',
    StoreLang: 'StoreLang',
    StoreLangList: 'StoreLangList',
    StoreLangTranslation: 'StoreLangTranslation',
    StoreFrontendSettings: 'StoreFrontendSettings',
  }),
  components: {
    PageInfo,
    SupportScreen,
  },
  props: {
    p_selectedSupportId: {
      type: String,
      required: false
    },
    p_callFrom: {
      type: String,
      required: false
    },
    p_refreshSupportList: {
      type: Boolean,
      required: false
    },
    f_updateMailInfo: {
      type: Function,
      required: false
    },
    p_mail: {
      type: Object,
      required: false
    },
    f_clearMailInfo: {
      type: Function,
      required: false
    },
    p_selectThisSupport: {
      type: Function,
      required: false
    }
  },
  data () {
    return {
      d_supportData: {
        'mail_status': true,
        'phone_status': true,
        'phone': '',
        'mail': '',
        'show': false,
        'edit_eligible': false,
        'operation_name': '',
        'operation_note': '',
        'operation_note_additional': '',
        'maximum_characters': 500,
        'subject': 'genel'
      },
      d_supportDataMail: {
        'maximum_characters_name': 100,
        'maximum_characters_note': 500,
        'mail_status': true,
        'phone_status': true,
        'phone': '',
        'mail': '',
        'show': false,
        'edit_eligible': true,
        'operation_name': '',
        'operation_note': '',
        'operation_note_additional': '',
        'maximum_characters': 500,
        'subject': 'General'
      },
      d_user: '',
      d_mail: '',
      d_hoverIndex: '',
      d_searchText: '',
      d_searchUser: '',
      d_frontendClientID: '',
      d_frontendList: [],
      d_userSupportList: [],
      d_usrSupportWdm: '',
      d_supportListLoading: false,
      ClsUser: ClsUser,
      d_selectedSupportTab: 'own',
      d_allSupportList: {},
      d_toBePassive: {
        'user_support': {},
        'mail_support': {}
      },
      d_passiveSelectedLoading: false,
    };
  },
  created: function () {
    ClsWdm.getLayerWdm('usr_support').then(resp_wdm_data => { this.d_usrSupportWdm = resp_wdm_data; });
    this.d_user = JSON.parse(localStorage.getItem('user'));
    if (this.p_mail) {
      this.d_mail = {
        'mail': this.p_mail['mail'],
        'mail_approve_code': this.p_mail['mail_approve_code'],
      }
    } else{
      this.d_mail = JSON.parse(localStorage.getItem('mail'));
    }
    if (this.d_user && this.d_user.username) {
      this.f_userSupportList();
    } else if (this.d_mail && this.d_mail['mail'] && this.d_mail['mail_approve_code']) {
      this.f_mailSupportList();
    }
  },
  beforeMount () {},
  mounted: function () {
    // console.log(this.StoreFrontendSettings);
    // console.log(this.d_usrSupportWdm);
  },
  methods: {
    f_passiveSelectedSupports: function () {
      // this.d_passiveSelectedLoading = true;
      let query = '';
      let data = {
        'user_supports': [],
        'mail_supports': []
      };
      for (let user_sup_id in this.d_toBePassive['user_support']) {
        if (this.d_toBePassive['user_support'][user_sup_id] == '1') {
          data['user_supports'].push(user_sup_id);
        }
      }
      for (let mail_sup_id in this.d_toBePassive['mail_support']) {
        if (this.d_toBePassive['mail_support'][mail_sup_id] == '1') {
          data['mail_supports'].push(mail_sup_id);
        }
      }
      console.log(data)
      ServiceFunctions.supports_to_passive(query, data)
        .then(resp => {
          this.d_passiveSelectedLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            this.f_getLastSupports();
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_getLastSupports: function () {
      this.d_userSupportList = [];
      this.d_allSupportList = {};
      this.d_toBePassive = {
        'user_support': {},
        'mail_support': {}
      }
      this.d_supportListLoading = true;
      let query = '';
      let data = {};
      ServiceFunctions.last_supports_get(query, data)
        .then(resp => {
          this.d_supportListLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            // if (resp.data.sql_result_list && resp.data.sql_result_list.parameters) {
            //   for (let i in resp.data.sql_result_list.parameters) {
            //     this.d_userSupportList.push(resp.data.sql_result_list.parameters[i]);
            //   }
            // } else {
            //   alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            // }
            if (resp.data.sql_result_list) {
              this.d_allSupportList = resp.data.sql_result_list;
              for (let sup_id in resp.data.sql_result_list['user_support']['parameters']) {
                this.d_toBePassive['user_support'][sup_id] = '0';
              }
              for (let sup_id in resp.data.sql_result_list['mail_support']['parameters']) {
                this.d_toBePassive['mail_support'][sup_id] = '0';
              }
            } else {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });

    },
    f_openSupportModal: function () {
      if (this.d_user && this.d_user.username) {
        this.f_supportModal();
      } else if (this.d_mail && this.d_mail['mail'] && this.d_mail['mail_approve_code']) {
        this.f_supportMailModal();
      }
    },
    f_selectThisSupport: function (client_id, support_type) {
      if (this.p_callFrom && this.p_callFrom == 'default_container') {
        // this.$emit('changeSupportId', (client_id, support_type));
        if (!support_type) {
          if (this.d_user && this.d_user.username) {
            support_type = 'user';
          } else {
            support_type = 'mail';
          }
        }
        this.p_selectThisSupport(client_id, support_type);
      }
    },
    f_dateFormat: function (date, date_type='year-month-day') {
      if (date) {
        if (date_type === 'year-month-day') {
          if (this.StoreLang === 'tr') {
            let x = moment(date, "YYYY-MM-DD hh:mm:ss").format("DD/MM/YYYY");
            return x;
          } else {
            let x = moment(date, "YYYY-MM-DD hh:mm:ss").format("YYYY/MM/DD");
            return x;
          }
        } else if (date_type === 'year-month-day hh:mm') {
          let x = moment(date, "YYYY-MM-DD hh:mm:ss").format("DD/MM/YYYY HH:MM");
          return x;
        }
      } else {
        return "";
      }
    },
    f_supportModal: function () {
      if (this.d_user) {
        this.d_supportData.show = true;
        this.d_supportData.edit_eligible = true;
        this.d_supportData.operation_name = '';
        this.d_supportData.operation_note = '';
      } else {
        this.$router.push({ path: '/login', query: {} });
      }
    },
    f_supportMailModal: function () {
      if (this.d_mail) {
        this.d_supportDataMail.show = true;
        this.d_supportDataMail.mail = this.d_mail.mail;
        this.d_supportDataMail.edit_eligible = true;
        this.d_supportDataMail.operation_name = '';
        this.d_supportDataMail.operation_note = '';
      } else {
        // this.$router.push({ path: '/login', query: {} });
      }
    },
    f_supportDetails: function (user_support_client_id) {
      let route_path = ClsRoute.f_getRoutePath('user_support_details', this.StoreLang);
      // console.log('route_path : ', route_path);
      this.$router.push({ path: route_path, query: { 'user_support_client_id': user_support_client_id } });
    },
    f_searchWdmritem: function (wdmr_item) {
      let res = false;
      if (this.d_searchText) {
        try {
          if (wdmr_item.data['0']['8']['val'].toLocaleLowerCase().indexOf(this.d_searchText.toLocaleLowerCase()) !== -1) {
            res = true;
          }
        } catch(err) {}
      } else {
        res = true;
      }
      return res;
    },
    f_userSupportList: function (username='') {
      this.d_userSupportList = [];
      this.d_supportListLoading = true;
      let query = '';
      if (username) {
        query += 'user_client_id=' + username;
      } else {
        query += 'user_client_id=' + this.d_user.username;
      }
      let data = {};
      ServiceFunctions.user_support_list(query, data)
        .then(resp => {
          this.d_supportListLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.list) {
              this.d_userSupportList = resp.data.list;
              // if (this.p_callFrom && this.p_callFrom == 'default_container') {
              //   this.p_selectedSupportId = '';
              //   this.$emit('changeSupportId', '');
              // }
            } else {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_mailSupportList: function (mail='') {
      this.d_userSupportList = [];
      this.d_supportListLoading = true;
      let query = '';
      let data = {};
      if (mail) {
        data['mail'] = mail
      } else {
        data['mail'] = this.d_mail['mail'];
        data['mail_approve_code'] = this.d_mail['mail_approve_code'];
      }
      // data.mail = 'enesyldddd@gmail.com';
      // data.mail_approve_code = '925187';
      ServiceFunctions.mail_support_list(query, data)
        .then(resp => {
          this.d_supportListLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.list) {
              this.d_userSupportList = resp.data.list;
              // if (this.p_callFrom && this.p_callFrom == 'default_container') {
              //   this.p_selectedSupportId = '';
              //   this.$emit('changeSupportId', '');
              // }
              // console.log(resp.data.list);
            } else {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            }
          } else if (resp.data.error && this.f_clearMailInfo) {
            alert(resp.data.status_code + ' = ' + resp.data.error);
            this.f_clearMailInfo();
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_userSupportTerminate: function (user_support_client_id) {
      this.d_userSupportList = [];
      let query = 'user_support_client_id=' + user_support_client_id;
      let data = {};
      ServiceFunctions.user_support_terminate(query, data)
        .then(resp => {
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            this.f_userSupportList();
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
  },
  watch: {
    'p_refreshSupportList': function () {
      if (this.p_refreshSupportList == true) {
        if (this.d_user && this.d_user.username) {
          this.f_userSupportList();
        } else if (this.d_mail && this.d_mail['mail'] && this.d_mail['mail_approve_code']) {
          this.f_mailSupportList();
        }
        this.$emit('changeRefreshSupportList', false);
      }
    },
    'p_mail': function () {
      this.d_mail = {
        'mail': this.p_mail['mail'],
        'mail_approve_code': this.p_mail['mail_approve_code'],
      }
    },
    'd_selectedSupportTab': function () {
      this.d_userSupportList = [];
      this.d_searchUser = '';
      if (this.d_selectedSupportTab == 'all') {
        this.f_getLastSupports();
      } else if (this.d_selectedSupportTab == 'own') {
        if (this.d_user && this.d_user.username) {
          this.f_userSupportList();
        } else if (this.d_mail && this.d_mail['mail'] && this.d_mail['mail_approve_code']) {
          this.f_mailSupportList();
        }
      }
    }
  }
};

</script>

<style>
  
  .selected{
    background-color: #D0E8FF;
  }

</style>

